export class EmailSettings {
  hide_paperless_branding: boolean;

  constructor(v: Partial<EmailSettings> = {}) {
    this.hide_paperless_branding = v.hide_paperless_branding;
  }
}
